import React, { useEffect, useState } from 'react'
import { Autocomplete, Chip, TextField } from '@mui/material'

/**
 * Multi-select for booking channel_type. Loads
 * /api/my-business/catalog/channel-types once on mount. Emits an array
 * of channel_type strings (including 'Unmapped' for unmapped channels).
 */
export default function ChannelSlicer({ value, onChange, sx }) {
	const [options, setOptions] = useState([])
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		fetch('/api/my-business/catalog/channel-types', { credentials: 'include' })
			.then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
			.then(setOptions)
			.catch(() => setOptions([]))
			.finally(() => setLoading(false))
	}, [])

	const selected = options.filter(o => value.includes(o.channel_type))

	return (
		<Autocomplete
			multiple
			size="small"
			options={options}
			loading={loading}
			value={selected}
			onChange={(_, picked) => onChange(picked.map(p => p.channel_type), { intent: 'pending' })}
			getOptionLabel={(o) => o.channel_type}
			isOptionEqualToValue={(a, b) => a.channel_type === b.channel_type}
			renderTags={(picked, getTagProps) =>
				picked.map((o, i) => (
					<Chip {...getTagProps({ index: i })} key={o.channel_type} size="small"
					      label={o.channel_type}/>
				))
			}
			renderInput={(params) => <TextField {...params} InputLabelProps={{ ...params.InputLabelProps, shrink: true }} label="Channels"/>}
			sx={{ minWidth: 200, ...sx }}
		/>
	)
}
